import { memo, useCallback, useState } from 'react';
import { TableProps } from '../..';
import {
  Flex,
  Popover,
  PopoverBody,
  PopoverTrigger,
  Button,
  PopoverContent,
  Link,
} from '@chakra-ui/react';
import * as Styles from '../../styles';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { checkPermission } from 'utils/authentication';
import { useRouteMatch } from 'react-router-dom';
import { useHistory } from 'react-router';
import { StatusTag } from 'components';
import { IUsersTable } from 'types/usersTable';
import { openNotification } from 'utils/notification';
import { changeStatusUser } from 'services/changeStatusUser';
import { getUsersData } from 'services/usersTable';
import { userStatusClient } from 'constants/users';
import { ModalActiveOrInactiveUser } from 'pages/Private/Users/NewUser/components';
import { useDisclosure } from '@chakra-ui/hooks';

interface BodyProps {
  rows: TableProps['rows'];
  sizes: string;
  row: TableProps['row'];
  path?: string | undefined;
  locations?: string[];
  data?: IUsersTable;
  enabled: boolean[];
  id: number[];
}

const BodyComponent: React.FC<BodyProps> = ({
  rows,
  sizes,
  row,
  path,
  locations,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data,
  enabled,
  id,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [newData, setNewData] = useState<IUsersTable>({ content: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [Index, setIndex] = useState<number>(0);
  const router = useRouteMatch();
  const query = location.search;
  const routeDemandsSAndParms = `${router.path}?page=0`;
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleGetData = async (query?: string) => {
    setIsLoading(true);
    try {
      const defaultQuery = 'size=10&sort=name,asc';
      let newQuery = `?${defaultQuery}`;

      if (query) {
        if (query[0] === '?') {
          newQuery = `${query}&${defaultQuery}`;
        } else {
          newQuery = `?${query}&${defaultQuery}`;
        }
      }

      const response = await getUsersData(newQuery);
      setNewData(response.data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const clickHandle = useCallback(
    index => {
      if (locations) {
        history.push(locations[index]);
      }
    },
    [locations],
  );

  const handleChangeStatus = async (userId: number, enabled: boolean) => {
    try {
      await changeStatusUser(userId, enabled);

      handleGetData(history.location.search);

      openNotification('Status alterado com sucesso');

      window.location.reload();
    } catch (error) {}
  };

  return (
    <Styles.TableBody>
      {rows.map((tr, trIndex) => (
        <Flex
          key={trIndex}
          align={'center'}
          marginBottom={'10px'}
          cursor={locations ? 'pointer' : ''}
        >
          <Styles.Tr
            sizes={sizes}
            key={`tr-${trIndex}`}
            onClick={() => {
              clickHandle(trIndex);

              routeDemandsSAndParms.includes('/users') &&
                localStorage.setItem('queryPageUser', query.slice(6));
            }}
          >
            {tr.map((td, tdIndex) => (
              <Styles.Td key={`td-${tdIndex}`}>{td || '-'}</Styles.Td>
            ))}
          </Styles.Tr>

          {checkPermission({ onlyAdmin: true }) &&
          routeDemandsSAndParms !== '/demands?page=0' &&
          !routeDemandsSAndParms.includes('/budgetControl') &&
          !routeDemandsSAndParms.includes('/users?page=') ? (
            <Flex alignItems={'center'} marginLeft={'10px'} className="containerFlex">
              <Popover>
                <PopoverTrigger>
                  <Button className="boxPopover">
                    <BsThreeDotsVertical />
                  </Button>
                </PopoverTrigger>

                <PopoverContent className="cardEdit" left={'-5rem'} top={'-3.5rem'}>
                  <Link href={'/' + path + row[trIndex]}>Editar</Link>
                </PopoverContent>
              </Popover>
            </Flex>
          ) : (
            ''
          )}
          {routeDemandsSAndParms.includes('users?page=') && (
            <>
              <div style={{ marginLeft: '.5rem' }}>
                <Popover>
                  <PopoverTrigger>
                    <Button className="boxPopover">
                      <BsThreeDotsVertical />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent
                    left={'-4.5rem'}
                    top={'-4.5rem'}
                    bg="rgb(255,255,255)"
                    border="1px solid #CCD1D6"
                    boxShadow={'0px 4px 20px rgba(0, 0, 0, 0.25)'}
                    borderRadius={4}
                  >
                    <PopoverBody className="boxEdit">
                      <Link
                        color="#000"
                        textDecor="none"
                        fontWeight={700}
                        fontSize="14px"
                        width="100%"
                        _hover={{ textDecoration: 'none' }}
                        // href={'/users/edit/' + id[trIndex]}
                        onClick={() => {
                          localStorage.setItem('url', 'page=0');
                          clickHandle(trIndex);
                        }}
                      >
                        Editar
                      </Link>
                      <StatusTag
                        style={{
                          cursor: 'pointer',
                          textAlign: 'start',
                          padding: 0,
                          fontSize: '14px',
                          fontWeight: 700,
                        }}
                        variant="transparent"
                        onClick={() => {
                          onOpen();
                          setIndex(trIndex);
                        }}
                      >
                        {enabled[trIndex] ? userStatusClient.inactive : userStatusClient.active}
                      </StatusTag>
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
              </div>
            </>
          )}
        </Flex>
      ))}
      <ModalActiveOrInactiveUser
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        users={userStatusClient}
        handleChangeStatus={handleChangeStatus}
        isLoading={isLoading}
        userEnadleb={enabled[Index]}
        id={id[Index]}
      />
    </Styles.TableBody>
  );
};

export const Body = memo(BodyComponent);
